(() => {
  /* Several sections load this file; the global listeners below must only be added once */
  if (window.glowQuickShopReady) return;
  window.glowQuickShopReady = true;

  /* Tabs: roving tabindex, arrow keys, Home/End */
  if (!customElements.get('glow-catalog')) {
    customElements.define(
      'glow-catalog',
      class GlowCatalog extends HTMLElement {
        connectedCallback() {
          this.tabs = [...this.querySelectorAll('[role="tab"]')];
          this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => this.select(index));
            tab.addEventListener('keydown', (event) => {
              const last = this.tabs.length - 1;
              const next = { ArrowRight: index + 1, ArrowLeft: index - 1, Home: 0, End: last }[event.key];
              if (next === undefined) return;
              event.preventDefault();
              const target = next > last ? 0 : next < 0 ? last : next;
              this.select(target);
              this.tabs[target].focus();
            });
          });
        }

        select(index) {
          this.tabs.forEach((tab, i) => {
            const active = i === index;
            tab.setAttribute('aria-selected', String(active));
            tab.tabIndex = active ? 0 : -1;
            const panel = document.getElementById(tab.getAttribute('aria-controls'));
            if (!panel) return;
            panel.hidden = !active;
            /* Cards in a freshly shown tab skip the scroll reveal */
            if (active) panel.querySelectorAll('[data-luxe-reveal] > *').forEach((card) => card.classList.add('is-luxe-in'));
          });
        }
      }
    );
  }

  /* Quick Shop sheets */
  const lockPage = (lock) => document.body.classList.toggle('overflow-hidden', lock);

  const bindSheet = (dialog) => {
    if (dialog.dataset.qsBound) return;
    dialog.dataset.qsBound = '';
    const data = JSON.parse(dialog.querySelector('[data-qs-data]').textContent);
    const variantInput = dialog.querySelector('[data-qs-variant]');
    const amount = dialog.querySelector('[data-qs-amount]');
    const compare = dialog.querySelector('[data-qs-compare]');
    const submit = dialog.querySelector('.glow-qs__submit');
    const label = dialog.querySelector('[data-qs-label]');
    const main = dialog.querySelector('[data-qs-main]');
    const thumbs = [...dialog.querySelectorAll('[data-qs-thumb]')];
    const quantity = dialog.querySelector('input[name="quantity"]');

    const showImage = (src, alt) => {
      if (!main || !src) return;
      main.removeAttribute('srcset');
      main.src = src;
      if (alt !== undefined) main.alt = alt;
      thumbs.forEach((thumb) => thumb.classList.toggle('is-active', thumb.dataset.qsThumb === src));
    };

    const update = () => {
      const chosen = [...dialog.querySelectorAll('[data-qs-option]:checked')].map((input) => input.value);
      const variant = data.variants.find((v) => v.options.every((value, i) => value === chosen[i]));
      if (!variant) {
        submit.disabled = true;
        label.textContent = data.unavailable;
        return;
      }
      variantInput.value = variant.id;
      amount.textContent = variant.price;
      compare.hidden = !variant.compare;
      if (variant.compare) compare.textContent = variant.compare;
      submit.disabled = !variant.available;
      label.textContent = variant.available ? data.addToCart : data.soldOut;
      if (variant.image) showImage(variant.image);
    };

    dialog.querySelectorAll('[data-qs-option]').forEach((input) => input.addEventListener('change', update));
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => showImage(thumb.dataset.qsThumb, thumb.dataset.qsAlt)));
    dialog.querySelectorAll('[data-qs-step]').forEach((button) =>
      button.addEventListener('click', () => {
        const next = Math.max(1, (parseInt(quantity.value, 10) || 1) + Number(button.dataset.qsStep));
        quantity.value = next;
      })
    );

    const close = () => {
      if (!dialog.open) return;
      dialog.classList.add('is-closing');
      const finish = () => {
        dialog.classList.remove('is-closing');
        dialog.close();
      };
      window.matchMedia('(prefers-reduced-motion: reduce)').matches ? finish() : setTimeout(finish, 280);
    };
    dialog.glowClose = close;

    dialog.querySelector('[data-quick-close]').addEventListener('click', close);
    /* A click on the backdrop (the dialog element itself, outside the sheet) closes it */
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) close();
    });
    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      close();
    });
    dialog.addEventListener('close', () => lockPage(false));
  };

  const open = (id, opener) => {
    const dialog = document.getElementById(id);
    if (!dialog || typeof dialog.showModal !== 'function') return;
    bindSheet(dialog);
    dialog.glowOpener = opener;
    dialog.showModal();
    lockPage(true);
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-quick-open]');
    if (!opener) return;
    event.preventDefault();
    open(opener.dataset.quickOpen, opener);
  });

  /* After a successful add, close the sheet so the cart notification (rendered right after) is visible */
  const watchCart = () => {
    /* constants.js / pubsub.js declare these as top-level bindings, not window properties */
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source !== 'product-form') return;
      document.querySelectorAll('dialog.glow-qs[open]').forEach((dialog) => {
        dialog.classList.remove('is-closing');
        dialog.close();
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchCart);
  } else {
    watchCart();
  }
})();
